import { useEffect, useRef } from 'react'

import { HISTORY_CALLER_STATUS } from '@reception-web/common/consts'
import { Trans, useTranslation } from 'react-i18next'
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'

const BACK_TIMEOUT_MILLISECONDS = 1000 * 30

import { Button, Text } from '../../components'
import { PATH } from '../../constants'
import {
  useDeviceIdProvider,
  useMeetingContext,
  useRedialApi,
} from '../../hooks'

export function CancelFrame() {
  const { getRoute, deviceId } = useDeviceIdProvider()
  const location = useLocation()
  const backTimer = useRef<NodeJS.Timeout | null>(null)
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'frames.DialFrame')
  const en = i18n.getFixedT('en', 'translation', 'frames.DialFrame')
  const [searchParams] = useSearchParams()
  const isTimeout = searchParams.get('isTimeout') === 'true'
  const { data: redialData } = useRedialApi(deviceId)
  const { setMeeting, setAttendee } = useMeetingContext()
  useEffect(() => {
    if (
      redialData?.call_type === 'redial_from_reception' &&
      redialData.caller_status === HISTORY_CALLER_STATUS.CALLING
    ) {
      navigate(getRoute(PATH.callback))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redialData])

  useEffect(() => {
    setMeeting(undefined)
    setAttendee(undefined)

    backTimer.current = setTimeout(() => {
      // Use window.location.assign to reset state
      window.location.assign(getRoute(PATH.root))
    }, BACK_TIMEOUT_MILLISECONDS)

    return () => {
      if (backTimer.current) {
        clearTimeout(backTimer.current)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(
    () => () => {
      if (backTimer.current) {
        clearTimeout(backTimer.current)
      }
    },
    [location.pathname]
  )

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-5 bg-off-white p-[60px]">
      <Text size="heading3" className="flex">
        {isTimeout ? (
          <>
            <Trans i18nKey="frames.DialFrame.error" tOptions={{ lng: 'ja' }} />
            <br />
            <Trans i18nKey="frames.DialFrame.error" tOptions={{ lng: 'en' }} />
          </>
        ) : (
          <>
            <Trans
              i18nKey="frames.DialFrame.canceled"
              tOptions={{ lng: 'ja' }}
            />
            <br />
            <Trans
              i18nKey="frames.DialFrame.canceled"
              tOptions={{ lng: 'en' }}
            />
          </>
        )}
      </Text>
      <Button
        fill
        className="my-5 h-[60px] w-[250px]"
        onClick={() => {
          navigate(getRoute(PATH.dial))
        }}
      >
        <Text size="lg2" weight="normal">
          {ja('tryAgain')}
          <br />
          {en('tryAgain')}
        </Text>
      </Button>
      <Link
        to={getRoute(PATH.root)}
        onClick={(e) => {
          e.preventDefault()
          // Use window.location.assign to reset state
          window.location.assign(getRoute(PATH.root))
        }}
      >
        <Text size="lg1">
          {ja('back')}
          <br />
          {en('back')}
        </Text>
      </Link>
    </div>
  )
}
